import { useEffect, useRef } from 'react';
import { uuidv4, showToastMessage } from '../../utils/commonFunctions';
import { getEnvVar } from '../../envUtils';

const useSocket = ({ scenarioId, onStatusDone, onStatusError }) => {
    const socketRef = useRef(null);
    const sessionIdRef = useRef(uuidv4());

    useEffect(() => {
        if (!scenarioId) return;

        const ws = new WebSocket(`${getEnvVar('REACT_APP_WEBSOCKET_BACKEND_BASE_URL')}test/scenario/prediction-deploy-event?resourceId=${scenarioId}&sessionId=${sessionIdRef.current}`);
        socketRef.current = ws;
        const token = sessionStorage.getItem("authentication");
        if (!ws || !token) return;

        ws.onopen = () => {
            ws.send(JSON.stringify({ type: 'authorization', token: `${token}` }));
            console.log("WebSocket connected");
        };

        ws.onerror = (err) => {
            console.error("WebSocket error:", err);
        };

        ws.onclose = () => {
            console.log("WebSocket closed");
        };

        return () => {
            ws.close();
        };
    }, [scenarioId]);


    useEffect(() => {
        const socket = socketRef.current;
        if (scenarioId && socket) {
            socket.onmessage = async (event) => {
                try {
                    const data = JSON.parse(event.data || '');
                    const missionId = data?.missionId
                    const scenarioId = data?.scenarioId
                    const satelliteId = data?.satelliteId
                    const groupId = data?.satelliteGroupId
                    if (data?.["status"] === "Done") {
                        await onStatusDone?.(missionId, scenarioId, satelliteId, groupId)
                    }
                    if (data?.["status"] === "Error") {
                        await onStatusError?.(missionId, scenarioId, satelliteId, groupId)
                        showToastMessage('error', 'Pre-sim is failed');
                    }
                } catch (error) {
                    console.error("Error parsing message:", error, event.data);
                }
            };
        }
    }, [scenarioId, onStatusDone]);
};

export default useSocket;
